import { getColor, getSize } from "views/resources/theme";
import styled from "styled-components";

export const Wrapper = styled.div`
	background-color: ${getColor("primary")};
`;

export const ProfileHeader = styled.div`
	color: #fff;
	text-align: center;
`;

ProfileHeader.Title = styled.div`
	height: 29px;
	width: 105px;
	color: #ffffff;
	font-size: ${getSize("l")};
	font-weight: 600;
	line-height: 29px;
	margin: 0 auto;
	margin-bottom: 10px;
`;

ProfileHeader.Description = styled.div`
	max-width: 288px;
	margin: 0 auto;
	font-size: ${getSize("sm")};
	font-weight: 500;
	line-height: 15px;
	margin-bottom: 25px;
`;

export const ProfilePicture = styled.div`
	height: 96px;
	width: 96px;
	border-radius: 3px;
	background-color: #ffffff;
	box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5);
	padding: ${getSize("s")};
	margin: 0 auto;
	margin-bottom: 24px;
`;

ProfilePicture.Image = styled.div`
	height: 100%;
	width: 100%;
	background-color: red;
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	background-color: ${getColor("bg")};
	/* border-radius: ${getSize("sm")} ${getSize("sm")} 0 0; */
	padding: ${getSize("l")};
	p {
		color: ${getColor("primary")};
		border-bottom: 1px solid #a0a0a0;
	}
`;

export const Toggle = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	overflow: hidden:
	-webkit-transform: translate3d(-50%, -50%, 0);
	transform: translate3d(-50%, -50%, 0);

input {
	position: absolute;
	left: -99em;
}

.toggle{
	cursor: pointer;
	display: inline-block;
	position: relative;
	width: 120px;
	height: 50px;
	background: #d21626;
	border-radius: 5px;
	-webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
	transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
}

.toggle:before, .toggle:after{
	position: absolute;
	line-height: 50px;
	font-size: 14px;
	z-index: 2;
	-webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
	transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
}
.toggle:before{
	content: "OFF";
	left: 20px;
	color: #D21626;
}
.toggle:after{
	content: "ON";
	right: 20px;
	color: #fff;
}
.toggle__handler{
	display: inline-block;
	position: relative;
	z-index: 1;
	background: #fff;
	width: 65px;
	height: 44px;
	border-radius: 3px;
	top: 3px;
	left: 3px;
	-webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
	transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
	-webkit-transform: translateX(0px);
	transform: translateX(0px);
}
input:checked + .toggle{
	background: #66b317;
}
input:checked + .toggle:before{
	color: #fff;
}
input:checked + .toggle:after{
	color: #66b317;
}
input:checked + .toggle .toggle__handler{
	width: 54px;
	-webkit-transform: translateX(60px);
	transform: translateX(60px);
	border-color: #fff;
}
`;
